import snapshot from './example-standard.json';
import { buildCoverage } from './coverage';
import { standardLabel } from './links';

/** A saved live Learning Commons search; no credentials or runtime API calls in the demo. */
export const EXAMPLE = {
  lesson: snapshot.query,
  standard: snapshot.standard,
  retrievedAt: snapshot.retrievedAt,
  label: standardLabel(snapshot.standard.jurisdiction, snapshot.standard.statementCode),
  finding: buildCoverage(
    [{ index: 0, text: snapshot.query }],
    [{ ...snapshot.standard, score: snapshot.score, segmentIndex: 0 }],
  ).findings[0]!,
};
